// @ts-strict-ignore
import React from 'react'
import i18next from 'i18next'
import { DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { PaymentMetadata } from 'types/transaction'

interface PaymentInProps {
  amountWithCurrency: string
  paidActualAmountWithCurrency: string
  transactionReference: string
  merchantId: string
  sourceAddress: string
  paymentMetadata?: PaymentMetadata
  currencyFrom?: string
  currencyTo?: string
}

const PaymentIn = ({
  amountWithCurrency,
  paidActualAmountWithCurrency,
  transactionReference,
  merchantId,
  sourceAddress,
  paymentMetadata,
  currencyFrom,
  currencyTo,
}: PaymentInProps) => {
  return (
    <>
      {amountWithCurrency && (
        <DataListItem
          id="amount-paid"
          testId="amount-paid"
          title={i18next.t('transactions.sideBar.paymentOutAmountPaid')}
          body={amountWithCurrency}
        />
      )}
      {paidActualAmountWithCurrency && (
        <DataListItem
          id="actual-amount-paid"
          testId="actual-amount-paid"
          title={i18next.t('transactions.sideBar.actualAmountPaid')}
          body={paidActualAmountWithCurrency}
        />
      )}
      {sourceAddress && (
        <DataListItem
          id="source-address"
          testId="source-address"
          title={i18next.t('transactions.sideBar.sourceAddress')}
          body={ellipseMiddleText(sourceAddress, 20, 10)}
          copyText={sourceAddress}
        />
      )}
      {merchantId && (
        <DataListItem
          id="merchant-id"
          testId="merchant-id"
          title={i18next.t('transactions.sideBar.merchantId')}
          body={merchantId}
        />
      )}
      {transactionReference && (
        <DataListItem
          id="transaction-reference"
          testId="transaction-reference"
          title={i18next.t('transactions.sideBar.reference')}
          body={ellipseMiddleText(transactionReference, 20, 10)}
          copyText={transactionReference}
        />
      )}
      {paymentMetadata?.exchangeRate && (
        <DataListItem
          id="exchange-rate"
          testId="exchange-rate"
          title={i18next.t('wallets.searchTransaction.exchangeRate')}
          body={`1 ${currencyFrom} = ${paymentMetadata?.exchangeRate} ${currencyTo}`}
        />
      )}
    </>
  )
}

export default PaymentIn
